module.exports = __webpack_public_path__ + "img/01.4728a163.png";